import React from 'react';
import './App.css';
import Navigation from "./components/navigation/Navigation";

function App() {
    return (
        <Navigation/>
    );
}

export default App;
